var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-zoom" },
    [
      _c(
        "i",
        {
          staticClass:
            "media-zoom__close material-icons p15 cl-bg-tertiary pointer",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v("close")]
      ),
      _vm._v(" "),
      _c(
        "no-ssr",
        [
          _vm.showProductGalleryZoomCarousel
            ? _c("product-gallery-zoom-carousel", {
                attrs: {
                  "current-slide": _vm.currentSlide,
                  gallery: _vm.gallery,
                  "product-name": _vm.productName
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }